import { render } from "./LabelStatus.vue?vue&type=template&id=2ee2e381&scoped=true"
import script from "./LabelStatus.vue?vue&type=script&lang=js"
export * from "./LabelStatus.vue?vue&type=script&lang=js"

import "./LabelStatus.vue?vue&type=style&index=0&id=2ee2e381&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee2e381"]])

export default __exports__